module.exports = __webpack_public_path__ + "static/werken-fbff46a0af972297788dbed2bde9243c.jpg";